export const LEAD_SOURCE_TYPE_CSV = "CSV"
export const LEAD_SOURCE_TYPE_MANUAL = "manual"
export const LEAD_SOURCE_TYPE_WEBHOOK = "webhook"
export const LEAD_SOURCE_TYPE_JOURNEY = "journey"